/**
 * Keycaps for the map screen's bindings. The dock tooltips and the
 * keyboard-shortcuts reference both derive their keycaps from these
 * constants, so the two cannot disagree.
 *
 * Zoom and pan are Google Maps' own bindings — they fire once the map canvas
 * has focus (a click or drag on the canvas focuses it). Center is ours,
 * registered by the map screen, and works anywhere on it.
 */
export const MAP_CENTER_SHORTCUT: readonly string[] = ["C"];
export const MAP_ZOOM_IN_SHORTCUT: readonly string[] = ["+"];
export const MAP_ZOOM_OUT_SHORTCUT: readonly string[] = ["-"];
export const MAP_PAN_SHORTCUT: readonly string[] = ["↑", "↓", "←", "→"];
